<ziro-collapsible-section-card
  data-automation="call-flows-side-nav"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.side_nav.title'"
  [cssClass]="'position-relative'"
>
  <div class="side-nav">
    <div class="side-nav__add-button">
      <ziro-button
        [label]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.add.label'"
        [dataAutomation]="'add-call-flow-button'"
        [icon]="ZiroIcons.ADD"
        [buttonStyle]="ButtonStyles.LINK"
        [buttonSize]="ButtonSizes.XSMALL"
        (clicked)="onAddHoliday()"
      ></ziro-button>
    </div>

    <p class="side-nav__sub-label mb-0">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.side_nav.standard.title' | translate }}
    </p>

    <ul class="nav flex-column list-unstyled mb-2" data-automation="standard-call-flows-list">
      @for (flow of standardCallFlows(); track flow.id) {
        @if (!flow.isHoliday) {
          <li
            class="nav-item side-nav__item d-flex p-0 align-items-center justify-content-between"
            [ngClass]="{ 'side-nav__item--active': selectedFlowId() === flow.id }"
            (click)="selectFlow(flow)"
            [attr.data-automation]="'call-flow-nav-item-' + flow.id"
          >
            <span
              class="side-nav__item-label d-block text-truncate"
              [attr.data-automation]="'call-flow-item-label-' + flow.id"
              [ngbTooltip]="tooltipOnTruncate(flow.name)"
            >
              {{ flow.name }}
            </span>

            <div class="d-flex align-items-center animate__animated animate__shakeX flex-shrink-0">
              @if (hasError(flow.id)) {
                <span
                  [class]="
                    ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                  "
                  data-automation="call-flow-error-icon"
                ></span>
              }
            </div>
            <ziro-button
              [cssClass]="'ms-1'"
              [dataAutomation]="'holiday-call-flow-copy-button'"
              [icon]="ZiroIcons.COPY"
              [buttonStyle]="ButtonStyles.LINK"
              [buttonSize]="ButtonSizes.XSMALL"
              (click)="onDuplicate(flow, $event)"
            ></ziro-button>
          </li>
        }
      }
    </ul>

    <p class="side-nav__sub-label mb-0">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.side_nav.holidays' | translate }}
    </p>

    @if (holidayCallFlows().length === 0) {
      <span class="text-muted side-nav__item">
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.side_nav.no_holidays' | translate }}
      </span>
    } @else {
      <ul class="nav flex-column list-unstyled" data-automation="holiday-call-flows-list">
        @for (flow of holidayCallFlows(); track flow.id) {
          <li
            class="nav-item side-nav__item d-flex p-0 align-items-center justify-content-between"
            [ngClass]="{ 'side-nav__item--active': selectedFlowId() === flow.id }"
            (click)="selectFlow(flow)"
            [attr.data-automation]="'call-flow-nav-item-' + flow.id"
          >
            <span class="flex-grow-1 text-truncate" [attr.data-automation]="'call-flow-item-label-' + flow.id">
              {{ flow.name }}
            </span>

            <div class="d-flex align-items-center ms-2">
              @if (hasError(flow.id)) {
                <span
                  [class]="
                    ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                  "
                  data-automation="call-flow-error-icon"
                ></span>
              }
              <ziro-button
                [cssClass]="'ms-1'"
                [dataAutomation]="'holiday-call-flow-copy-button'"
                [icon]="ZiroIcons.COPY"
                [buttonStyle]="ButtonStyles.LINK"
                [buttonSize]="ButtonSizes.XSMALL"
                (click)="onDuplicate(flow, $event)"
              ></ziro-button>

              <ziro-button
                [cssClass]="'ms-1 text-danger btn-border'"
                [dataAutomation]="'holiday-call-flow-delete-button'"
                [icon]="ZiroIcons.DELETE_SMALL"
                [buttonStyle]="ButtonStyles.OUTLINE_DANGER"
                [buttonSize]="ButtonSizes.XSMALL"
                (click)="onDelete(flow, $event)"
              ></ziro-button>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</ziro-collapsible-section-card>
